export default [
  // 车型画册-车型选择列表
  {
    path: '/product-album',
    component: () => import('@/views/product/album/Index.vue'),
    name: 'product-album',
    meta: {
      auth: 0,
      keepAlive: true,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 车型画册-车型详情
  {
    path: '/product-album-detail-:vehicleTypeId',
    component: () => import('@/views/product/album/Detail.vue'),
    name: 'product-album-detail',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 车型画册-车辆图库
  {
    path: '/product-gallery',
    component: () => import('@/views/product/gallery/Index.vue'),
    name: 'product-gallery',
    meta: {
      translateKey: 'cfmoto.vehicleGallery',
      auth: 0,
      keepAlive: true,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
  // 车型画册-车辆图库详情
  {
    path: '/product-gallery-:vehicleTypeId',
    component: () => import('@/views/product/gallery/Detail.vue'),
    name: 'product-gallery-detail',
    meta: {
      auth: 0,
      visibleShare: true,
      backgroundClass: 'bg-white',
    },
  },
];
